import styled from 'styled-components';

export const DayEntryWrapper = styled.div<{
  isDragging: boolean;
  primaryColor?: string;
  secondaryColor?: string;
}>`
  border: 1px solid
    ${({ theme, secondaryColor }) => secondaryColor || theme.colors.grayVariations.light};
  border-radius: 10px;
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  transform: translate(0, 0);
  opacity: ${({ isDragging }) => (isDragging ? 0 : 1)};

  ${({ primaryColor }) => primaryColor && `background-color: ${primaryColor}`};
`;

export const IconDot = styled.div<{ secondaryColor?: string }>`
  border-radius: 100%;
  width: 3px;
  height: 3px;
  background-color: ${({ secondaryColor, theme }: any) =>
    secondaryColor || theme.colors.grayVariations.medium};
`;

export const IconDotsWrapper = styled.div<{ isDisabled: boolean }>`
  display: grid;
  grid-gap: 2px;
  grid-template-columns: repeat(2, 1fr);
  width: 6px;
  margin-right: 14px;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  & > div {
    opacity: ${({ isDisabled }) => (isDisabled ? 0.3 : 1)};
  }
`;

export const StripeNameWrapper = styled.div`
  display: flex;
  align-items: center;
`;
